<template>
  <div
    v-if="announcement && announcement.entries && announcement.entries.length > 0"
    class="bg-brown-75 flex items-center overflow-clip p-[12px] rounded-[16px] w-full"
  >
    <div class="flex flex-col gap-[12px] items-end w-full">
      <!-- Title (editable from CMS) -->
      <p
        class="font-inter font-extrabold -tracking-[0.16px] leading-[1.5rem] md:leading-[1.75rem] lg:leading-[2rem] text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] text-[#21201E] w-full"
      >
        {{ announcement.title }}
      </p>

      <!-- Entries -->
      <div class="flex flex-col gap-[4px] items-start w-full">
        <div
          v-for="(entry, index) in announcement.entries"
          :key="entry.id || index"
          class="flex gap-[2px] items-start w-full"
        >
          <!-- Icon -->
          <div class="shrink-0 size-[20px] md:size-[24px] flex items-center justify-center">
            <span class="text-[0.875rem] md:text-[1rem] leading-[1.25rem]">{{ entry.icon }}</span>
          </div>

          <!-- Message -->
          <div
            class="font-inter font-normal text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] leading-[1.5rem] md:leading-[1.75rem] lg:leading-[2rem] text-[#373531] flex-1"
          >
            {{ entry.message }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainingAnnouncements',
  props: {
    announcement: {
      type: Object,
      default: null,
    },
  },
};
</script>
